import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

const LanguageSelector = () => {
  const { i18n, t } = useTranslation();
  const { updateLanguage, currentUser } = useAuth();

  const changeLanguage = (lng) => {
    if (currentUser) {
      // If user is logged in, update preference in backend
      updateLanguage(lng);
    } else {
      // If not logged in, just change the language locally
      i18n.changeLanguage(lng);
    }
  };

  return (
    <div className="dropdown">
      <button 
        className="btn btn-sm btn-outline-secondary dropdown-toggle" 
        type="button" 
        id="languageDropdown" 
        data-bs-toggle="dropdown" 
        aria-expanded="false"
      >
        <i className="fas fa-globe me-1"></i>
        {t(`language.${i18n.language}`)}
      </button>
      <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="languageDropdown">
        <li>
          <button 
            className={`dropdown-item ${i18n.language === 'en' ? 'active' : ''}`} 
            onClick={() => changeLanguage('en')}
          >
            {t('language.en')}
          </button>
        </li>
        <li>
          <button 
            className={`dropdown-item ${i18n.language === 'de' ? 'active' : ''}`} 
            onClick={() => changeLanguage('de')}
          >
            {t('language.de')}
          </button>
        </li>
      </ul>
    </div>
  );
};

export default LanguageSelector;
